import { round } from 'lodash'

export interface ProductImageContent {
    image: string; // base64
    isMain?: boolean;
    isActive?: boolean;
}

const A_MILLION_BYTES = 2**20
const A_THOUSAND_BYTES = 2**10

export class ProductImageModel {
    id?:number = undefined
    url:string = ''
    isMain:boolean = false
    byteLength?:number = 0
    isActive:boolean = false
    height:number = 0;
    width:number = 0;

    constructor(p?:Partial<ProductImageModel>) {
        Object.assign(this, p)
    }

    hasId():boolean {
        return !!this.id
    }

    getSizeInformation() {
        if (!this.height || !this.width || !this.byteLength) {
            return ''
        }

        if (this.byteLength < A_MILLION_BYTES) {
            return `${this.width} x ${this.height} (${this.getSizeInKbytes()}KB)`
        }

        return `${this.width} x ${this.height} (${this.getSizeInMegabytes()}MB)`
    }

    getSizeInKbytes():number {
        if (!this.byteLength) {
            return 0
        }

        return round(this.byteLength / A_THOUSAND_BYTES, 0)
    }

    getSizeInMegabytes():number {
        if (!this.byteLength) {
            return 0
        }

        return round(this.byteLength / A_MILLION_BYTES, 2)
    }
}

